export default __webpack_public_path__ + "static/media/miscellaneous-mobile-bg.07f2ab2c.webp";